//获取证券的 K 线数据。
import { callWithRetry } from './tdx-conn-manager'
import { getMinuteTimeData, getSecurityBars, getSecurityQuotes } from './tdx-hq-util'

//K线种类, 0->5分钟K线    1->15分钟K线    2->30分钟K线  3->1小时K线    4->日K线  5->周K线  6->月K线  7->1分钟  8->1分钟K线  9->日K线  10->季K线  11->年K线
//0-->深圳     1->上海
export const callSecurityBars = async (category = 4, market: number, zqdm: string, start?: number, count?: number) => {
  return await callWithRetry(getSecurityBars, {
    category: category,
    market: market,
    zqdm: zqdm,
    start: start??0,
    count: count??30,
  })
}
//0-->深圳     1->上海
export const callMinuteTimeData = async (market: number, zqdm: string) => {
  return await callWithRetry(getMinuteTimeData, {
    market: market,
    zqdm: zqdm
  })
}

export const callSecurityQuotes = async (market: number, zqdm: string) => {
  return await callWithRetry(getSecurityQuotes, {
    markets: [market],
    zqdms: [zqdm]
  })
}

